import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);

export async function createPayment(sessionId: string, lang: string = 'de') {
  try {
    const stripe = await stripePromise;
    if (!stripe) throw new Error('Stripe konnte nicht geladen werden');

    // Create checkout session with language parameter
    const response = await fetch('/.netlify/functions/create-payment-intent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        sessionId, 
        lang 
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Netzwerkfehler' }));
      throw new Error(errorData.error || `HTTP-Fehler! Status: ${response.status}`);
    }

    const data = await response.json();
    if (!data.sessionId) {
      throw new Error('Keine Session-ID erhalten');
    }

    // Redirect to Stripe Checkout
    const { error } = await stripe.redirectToCheckout({
      sessionId: data.sessionId
    });

    if (error) {
      throw error;
    }

    return {
      success: true,
      paymentUrl: window.location.href,
    };
  } catch (error) {
    console.error('Zahlungsfehler:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Zahlung fehlgeschlagen'
    };
  }
}